export const DEFAULT_LIMIT = 28;

export const DEFAULT_PAGE = 1;
